<template>
    <div>
        <v-container>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col class="teal lighten-2 font-weight-bold">Vendor</v-col>
                        <v-col class="teal lighten-2 font-weight-bold" cols="4">Teknis</v-col>
                        <v-col class="teal lighten-2 font-weight-bold">Harga Penawaran</v-col>
                        <v-col class="teal lighten-2 font-weight-bold">Harga Negosiasi</v-col>
                    </v-row>
                    <v-divider />
                    <v-row v-for="item in listEvaluasi" :key="item.id">
                        <v-col> {{ item.nama }} </v-col>
                        <v-col cols="4"> <v-textarea v-model="item.negosiasiTeknis" counter="200" row-height="12px" auto-grow outlined :readonly="readonly"  /> </v-col>
                        <v-col> <text-field-rupiah v-model="item.nilaiPenawaran" readonly /> </v-col>
                        <v-col> <text-field-rupiah v-model="item.negosiasiHarga" :readonly="readonly" /> </v-col>
                    </v-row>
                    <v-row>            
                        <v-col> <v-btn v-if="!readonly" color="green" dark @click="simpanEvaluasi()">Simpan Evaluasi</v-btn> </v-col>            
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>

        <!-- Notification -->
        <v-snackbar
            v-model="notification.show"
            :color="notification.color"
            :top="true"
            :right="true"
            :timeout=3000
        >
            {{notification.text}}
        </v-snackbar>

        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>    
</template>


<script>
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from "axios";
import TextFieldRupiah from "./../TextFieldRupiah.vue";


export default {
    components: {
        "text-field-rupiah": TextFieldRupiah
    },

    props: {
        readonly: {
            type: Boolean,
            default: false
        }

    }, // props


    data() {
        return {
            listEvaluasi: [],

            notification: {
                show: false,
                color: "success", 
                text: "",
            },

            submitting: false,
        }

    }, // data


    computed: {
        paket: function() {
            return this.$store.getters['lelang/paket']
        },

    }, // computed


    watch: {
        paket() {
            this.getData();
        }

    }, // watch


    mounted() {
        this.getData();
    }, // mounted


    methods: {
        getData() {
            this.listEvaluasi = [];
            axios.get(`${apiUrl}/api/lelang/evaluasi/${this.paket.id}`)
            .then( (response) => {
                this.listEvaluasi = response.data;
            })
            .catch( (error) => {
                console.error(error);
            });
        },

        simpanEvaluasi() {  
            this.submitting = true;

            const fdata = {
                paketPenyediaId: this.paket.id,
                listEvaluasi: this.listEvaluasi
            };

            axios.put(`${apiUrl}/api/lelang/negosiasi`, fdata)
            .then( () => {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Hasil negosiasi berhasil disimpan"
                }
            })
            .catch( (error) => {
                console.error(error);
                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal simpan hasil negosiasi [${error.message}]`
                }
            })
            .finally( () => {
                this.submitting = false;
            });
        },

    }, // methods

}
</script>
